import { GetterTree } from "vuex";
import { IDocumentState } from "@/store/modules/document/state";
import { Document } from "@/types";

import { IDataProvider, IRootState } from "@/store";

export enum DocumentGetters {
  GET_ALL = "GET_ALL_DOCUMENT",
  GET_CURRENT = "GET_CURRENT_DOCUMENT",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_DOCUMENT",
  GET_FILE = "GET_FILE_DOCUMENT",
}

export const getters: GetterTree<IDocumentState, IRootState> = {
  [DocumentGetters.GET_ALL](state): Document[] | null {
    return state.documents;
  },
  [DocumentGetters.GET_CURRENT](state): Document | null {
    return state.document;
  },
  [DocumentGetters.GET_DATA_PROVIDER](state): IDataProvider<Document> | null {
    return state.dataProvider;
  },
  [DocumentGetters.GET_FILE](state): Blob | null {
    return state.file;
  },
};
